import * as api from '../../api';

const checkResponse = request =>
    request.then(response => {
        if (response.error) {
            throw new Error(response.error);
        }
        return typeof response.data !== 'undefined' ? response.data : response;
    });

export const getCode = password =>
    checkResponse(api.post(`/api/account/reset/code`, { password }));
